import { useEffect } from 'react';

import { modalStore } from '@/stores/modal';

// 监听页面 返回激活状态
const useRefreshModalInOnactive = () => {
  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const modalOpen = modalStore.modalOpen;
        if (modalOpen === 'firstRecharge') {
          modalStore.refreshFirstRecharge();
        }
        if (modalOpen === 'pochan') {
          modalStore.refreshPochan();
        }
        if (modalOpen === 'daily-package') {
          modalStore.refreshDailyPackage();
        }
        if (modalOpen === 'jieti') {
          modalStore.refreshJieti();
        }
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);

  return null;
};

export default useRefreshModalInOnactive;
